<template>
  <div>
    <section class="content">
      <v-row>
        <v-col cols="12" xs="3" md="3">
          <!-- Reload button -->
          <v-btn color="secondary" small @click.stop="reloadAll()">
            Reload All
            <i class="fa fa-repeat"></i>
          </v-btn>
          <v-btn small @click.prevent="openReportPasscodeDialog">Export</v-btn>
          <!-- Excel Import -->
          <!-- <v-btn @click="$refs.igBulkHandle.click()" small v-if="isAdminRole">
            <v-icon left>mdi-home-import-outline</v-icon>Import Excel
          </v-btn>
          <v-btn @click="downloadSampleUpload" small>
            <v-icon left>mdi-download</v-icon>Download Sample Import
          </v-btn> -->
          <v-btn
            small
            color="warning"
            :disabled="!selectedLists || selectedLists.length === 0"
            @click="openAddPairingCampaignModal()"
            v-show="selectedLists.length > 0"
          >Add to Pairing ({{selectedLists.length}})</v-btn>
        </v-col>
        <v-col cols="12" xs="9" md="9">
          <v-row justify="right" align="center" style="width:100%;justify-content:right">
            <v-col class="pr-0" cols="12" xs="12" md="2" lg="2">
              <v-select
                outlined
                dense
                hide-details="auto"
                :items="platformList"
                item-value="value"
                item-text="text"
                v-model="selectedPlatform"
                @change="paginate()"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="5" lg="5">
              <v-text-field
                outlined   
                dense         
                label="Search Handle"
                v-model="igHandle"
                hide-details="auto"
                id="igHandle"
                @keyup.enter="paginate()"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="right" align="center" style="margin:30px 0px 0px 0px;">
        <!-- <v-col cols="12" xs="12" md="1" lg="1" align="right">
          <div style="font-size:16px;font-weight:400;">Filters:</div>
        </v-col> -->
        <!-- <v-col cols="12" xs="12" md="2" lg="2">
          <v-select
            outlined
            dense
            hide-details="auto"
            :items="platformList"
            item-value="value"
            item-text="text"
            v-model="selectedPlatform"
            @change="paginate()"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-text-field
            outlined   
            dense         
            label="Handle"
            v-model="igHandle"
            hide-details="auto"
            id="igHandle"
            @keyup.enter="paginate()"
          ></v-text-field>
        </v-col> -->
        <v-col cols="12" xs="12" md="2" lg="2">         
          <v-autocomplete
            v-model="influencerGeos"
            :items="countries"
            dense
            hide-selected       
            clearable
            small-chips
            outlined
            hide-details="auto"
            label="Country"
            @change="paginate()"                    
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-select
            outlined
            dense
            hide-details="auto"
            label="Gender"
            :items="searchConfig.genderOptions"
            item-value="value"
            item-text="text"
            v-model="searchFilter.gender"
            @change="paginate()"
          ></v-select>
        </v-col>
        <!-- <v-col cols="12" xs="12" md="1" lg="1">
           <v-checkbox
            class="mt-0"
            v-model="searchFilter.isIMS"
            label="IMS Only"
            color="secondary"
            value="orange"
            hide-details
            @change="paginate()"
          ></v-checkbox>
        </v-col> -->
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-select
            outlined
            dense
            hide-details="auto"
            label="IMS Status"
            :items="searchConfig.imsOptions"
            item-value="value"
            item-text="text"
            v-model="searchFilter.isIMS"
            @change="paginate()"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-autocomplete
            outlined
            dense 
            clearable
            hide-details="auto"
            label="Campaigns"
            :items="filterCampaigns"
            item-value="id"
            item-text="name"
            v-model="searchFilter.campaign"
            @change="paginate()"
          ></v-autocomplete>
        </v-col>
        <!-- <v-col cols="12" xs="12" md="2" lg="2">
          <v-autocomplete
            outlined
            dense 
            clearable
            hide-details="auto"
            label="Campaign Type"
            :items="filterCampaignTypes"
            item-value="name"
            item-text="title"
            v-model="searchFilter.campaignType"
            @change="paginate()"
          ></v-autocomplete>
        </v-col> -->
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-autocomplete
            outlined
            dense 
            clearable
            hide-details="auto"
            label="Aud. Credibilty"
            :items="audCredibilities"
            v-model="searchFilter.credibility"
            @change="paginate()"
          >
            <template #item="{ item }">
              <v-chip
                style="width:100%"
                x-small
                :color="item"
                text-color="white"
              ></v-chip>
            </template>
            <template #selection="{ item }">
              <v-chip
                style="width:100%;margin-top:10px;margin-bottom:-26px"
                x-small
                :color="item"
                text-color="white"
              ></v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" xs="12" md="2" lg="2">
          <v-autocomplete
            v-model="searchFilter.infInterest"
            :items="audienceInterestLists"
            item-text="name"
            item-value="name"
            hide-selected
            multiple            
            clearable
            small-chips
            dense
            outlined
            hide-details="auto"
            label="Influencer Interests"              
            @change="paginate()"
          >
            <template v-slot:selection="data">
              <v-chip :input-value="data.selected" close @click:close="removeInfInterest(data.item)">
                <strong>{{ data.item.name }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ml-0" align="center">
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width: 175px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
            style="min-height: 250px;"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Aud. Country <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="100px">
              <v-list-item>
                <p class="subtitle-2 mb-0">Select Countries</p>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-2" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      v-model="audGeos"
                      :items="countries"
                      dense
                      hide-selected
                      multiple            
                      clearable
                      small-chips
                      outlined
                      hide-details="auto"
                      label="Aud. Country"                 
                    >
                      <template v-slot:selection="data">
                        <v-chip small :input-value="data.selected" close @click:close="removeAudGeos(data.item)">
                          <strong>{{ data.item }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-5" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgePercentOptions"
                      v-model="audGeoPercent"
                      style="max-width:120px;"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-list class="pt-5">
              <v-list-item style="min-height:0">
                <p class="subtitle-2 mb-0">Size</p>
              </v-list-item>
              <v-list-item min-height="150px">
                <v-autocomplete
                  outlined
                  dense
                  hide-details="auto"
                  :items="searchConfig.limitOptions"
                  v-model="searchFilter.limit"
                  style="max-width:120px;"
                ></v-autocomplete>
              </v-list-item>
            </v-list>
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width: 150px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Followers <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="100px">
              <v-list-item>
                <v-row>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    From
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.followerOptions.from"
                      v-model="searchFilter.followers.from"
                      style="max-width:120px;" 
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    To
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.followerOptions.to"
                      v-model="searchFilter.followers.to"
                      style="max-width:120px;"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width: 150px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
            style="min-height: 250px;"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Age Group <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="100px">
              <v-list-item>
                <p class="subtitle-2 mb-0">Audience</p>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-2" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgeOptions"
                      v-model="searchFilter.ageGroup"
                      style="max-width:100%;"
                    ></v-autocomplete>
                  </v-col>
                  <!-- <v-col class="pt-2" cols="12" xs="12" md="6" lg="6">
                    From
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.ageOptions.from"
                      v-model="searchFilter.ageGroup.from"
                      @change="paginate()"
                      style="max-width:120px;" 
                    ></v-combobox>
                  </v-col>
                  <v-col class="pt-2" cols="12" xs="12" md="6" lg="6">
                    To
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.ageOptions.to"
                      v-model="searchFilter.ageGroup.to"
                      @change="paginate()"
                      style="max-width:120px;"
                    ></v-combobox>
                  </v-col> -->
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-5" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgePercentOptions"
                      v-model="searchFilter.ageGroupPercent"
                      style="max-width:120px;"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>

            <v-list min-height="100px">
              <v-list-item>
                <p class="subtitle-2 mb-0">2nd Deg. Audience</p>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-2" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgeOptions"
                      v-model="searchFilter.secAgeGroup"
                      style="max-width:100%;"
                    ></v-autocomplete>
                  </v-col>
                  <!-- <v-col class="pt-2" cols="12" xs="12" md="6" lg="6">
                    From
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.ageOptions.from"
                      v-model="searchFilter.secAgeGroup.from"
                      @change="paginate()"
                      style="max-width:120px;" 
                    ></v-combobox>
                  </v-col>
                  <v-col class="pt-2" cols="12" xs="12" md="6" lg="6">
                    To
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.ageOptions.to"
                      v-model="searchFilter.secAgeGroup.to"
                      @change="paginate()"
                      style="max-width:120px;"
                    ></v-combobox>
                  </v-col> -->
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-5" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgePercentOptions"
                      v-model="searchFilter.secAgeGroupPercent"
                      style="max-width:120px;"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-list class="pt-5">
              <v-list-item style="min-height:0">
                <p class="subtitle-2 mb-0">Size</p>
              </v-list-item>
              <v-list-item min-height="150px">
                <v-autocomplete
                  outlined
                  dense
                  hide-details="auto"
                  :items="searchConfig.limitOptions"
                  v-model="searchFilter.limit"
                  style="max-width:120px;"
                ></v-autocomplete>
              </v-list-item>
            </v-list>
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width: 180px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Aud. Interests <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="150px">
              <!-- <v-list-item>
                <v-list-item-title>Influencer</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-0" cols="12" xs="12" md="12" lg="12">
                   <v-combobox
                      v-model="searchFilter.infInterest"
                      :items="audienceInterestLists"
                      item-text="name"
                      item-value="id"
                      hide-selected
                      multiple            
                      clearable
                      small-chips
                      dense
                      outlined
                      hide-details="auto"
                      label="Influencer Interests"              
                    >
                      <template v-slot:selection="data">
                        <v-chip :input-value="data.selected" close @click:close="removeInfInterest(data.item)">
                          <strong>{{ data.item.name }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-col>
                </v-row>
              </v-list-item> -->
              <v-list-item>
                <v-list-item-title>
                  <p class="subtitle-2 mb-0">Select</p>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-0" cols="12" xs="12" md="12" lg="12">
                   <v-autocomplete
                      v-model="searchFilter.audienceInterest"
                      :items="audienceInterestLists"
                      item-text="name"
                      item-value="name"
                      hide-selected
                      multiple            
                      clearable
                      small-chips
                      dense
                      outlined
                      hide-details="auto"
                      label="Audience Interests"              
                    >
                      <template v-slot:selection="data">
                        <v-chip :input-value="data.selected" close @click:close="removeAudInterest(data.item)">
                          <strong>{{ data.item.name }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col class="pt-5" cols="12" xs="12" md="12" lg="12">
                    <v-autocomplete
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.creatorAgePercentOptions"
                      v-model="audInterestPercent"
                      style="max-width:120px;"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-list class="pt-5">
              <v-list-item style="min-height:0">
                <p class="subtitle-2 mb-0">Size</p>
              </v-list-item>
              <v-list-item min-height="150px">
                <v-autocomplete
                  outlined
                  dense
                  hide-details="auto"
                  :items="searchConfig.limitOptions"
                  v-model="searchFilter.limit"
                  style="max-width:120px;"
                ></v-autocomplete>
              </v-list-item>
            </v-list>
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="12" md="1" lg="1" style="min-width: 175px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Engagements <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="150px">
              <!-- <v-list-item>
                <v-list-item-title>Engagements</v-list-item-title>
              </v-list-item>
              <v-list-item class="mb-2">
                <v-row>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    From
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.engRateOptions.from"
                      v-model="searchFilter.engagements.from"
                      @change="paginate()"
                      style="max-width:120px;" 
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    To
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.engRateOptions.to"
                      v-model="searchFilter.engagements.to"
                      @change="paginate()"
                      style="max-width:120px;"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-list-item> -->

              <v-list-item>
                <v-list-item-title>Engagement Rate</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-row>
                  <v-col cols="12" xs="12" md="12" lg="12">
                    To (%)
                    <v-autocomplete
                      class="mt-2"
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.engRatePercentageOptions.to"
                      v-model="searchFilter.engagementRate.to"
                      style="max-width:120px;"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" xs="12" md="2" lg="2" style="max-width:250px;">
          <v-menu
            offset-y
            bottom
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                Paid Post Performance <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

            <v-list min-height="100px">
              <v-list-item>
                <v-row>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    From (%)
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.paidPstPerformanceOptions.from"
                      v-model="searchFilter.paidPstPerformance.from"
                      style="max-width:120px;" 
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" xs="12" md="6" lg="6">
                    To (%)
                    <v-combobox
                      outlined
                      dense        
                      clearable
                      hide-details="auto"
                      :items="searchConfig.paidPstPerformanceOptions.to"
                      v-model="searchFilter.paidPstPerformance.to"
                      style="max-width:120px;"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
            <v-list min-height="100px" style="min-height:60px;margin-top:-28px">
              <v-list-item style="float:right">
                <v-btn color="secondary" small @click.stop="paginate()">
                  Apply
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="ml-3 mt-5" align="center" v-if="showFilters">
        <div class="d-flex flex-row flex-wrap">
          <p class="body-2 mr-2 pt-2">Filters:</p>
          <div v-for="(item, index) in getFilterLists" :key="index">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip class="mr-2" color="default">
                  <v-icon v-on="on" left>{{item.icon}}</v-icon>
                  <span v-if="item.value">{{item.value}}</span>
                  <span v-if="item.htmlValue" v-html="item.htmlValue"></span>
                  <v-btn class="btn-close" @click="removeFilterShow(item.type)" text>
                    <v-icon v-on="on" left>mdi-close</v-icon>
                  </v-btn>
                </v-chip>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
          </div>
          <!-- <v-chip class="mr-2" color="default" v-if="mainCountryFilter">
            <v-icon v-on="on" left>mdi-account</v-icon> {{mainCountryFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('mainCountry')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="genderFilter">
            <v-icon v-on="on" left>mdi-account</v-icon> {{genderFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('gender')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="countryFilter">
            <v-icon v-on="on" left>mdi-account-multiple</v-icon> {{countryFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('country')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="followerFilter">
            <v-icon v-on="on" left>mdi-bullhorn</v-icon> {{followerFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('follower')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="ageGroupFilter">
            <v-icon v-on="on" left>mdi-account-multiple</v-icon> {{ageGroupFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('ageGroup')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="infInterestsFilter">
            <v-icon v-on="on" left>mdi-account</v-icon> {{infInterestsFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('infInterests')"  text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="audInterestsFilter">
            <v-icon v-on="on" left>mdi-account-multiple</v-icon> {{audInterestsFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('audienceInterest')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="engRateFilter">
            <v-icon v-on="on" left>mdi-bullhorn</v-icon> {{engRateFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('engRate')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip>
          <v-chip class="mr-2" color="default" v-if="paidPstFilter">
            <v-icon v-on="on" left>mdi-bullhorn</v-icon> {{paidPstFilter}}
            <v-btn class="btn-close" @click="removeFilterShow('paidPst')" text>
              <v-icon v-on="on" left>mdi-close</v-icon>
            </v-btn>
          </v-chip> -->
        </div>
      </v-row>
      <v-row class="pt-0 pb-0">
        <v-col cols="12" xs="12" md="12" lg="12" class="pt-0 pb-0">
          <div style="text-align:right!important;">
            <v-menu
              :close-on-content-click="false"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  @click="openColSettingsModal"
                >
                  <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                </v-btn>
              </template>
            </v-menu>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" xs="12" md="12">
          <button
                id="viewCompany"
                style="display: none"
                data-toggle="modal"
                :data-target="viewCompanyModalIdDisplay"
              ></button>
              <button
                id="viewPosts"
                style="display: none"
                data-toggle="modal"
                :data-target="influencerPostDisplay"
              ></button>
              <v-data-table
                :headers="computedHeaders"
                :items="items"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="{
                  itemsPerPageOptions: rowsPerPageItems
                }"
                :server-items-length="totalItems"
                item-key="id"
                class="table-small elevation-1"
                show-select
                :single-select="false"
                v-model="selectedLists"
                @toggle-select-all="selectAllLists"
              >
                <template v-slot:[`item.data-table-select`]="{item}">
                  <div class="d-flex flex-row" style="margin-left:18px">
                    <v-checkbox
                      style="margin-right:-12px"
                      v-model="selectedLists"
                      label=""
                      :value="item"
                      color="grey darken-2"
                    ></v-checkbox>
                    <v-btn
                      style="margin-top:22px"
                      class="btn-reload"
                      text
                      x-small
                      color="secondary"
                      @click="refreshReport(item)"
                    >
                      <v-icon dark small>
                        mdi-reload
                      </v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:[`item.profilePicture`]="{ item }">
                  <tr>
                    <td>
                      <v-avatar :size="avatarSize" color="grey lighten-4">
                        <img v-bind:src="paserImageUrl(item.profilePicture)" alt="avatar" />
                      </v-avatar>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.instagramHandle`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <a
                        target="_blank"
                        v-bind:href="'https://www.tiktok.com/@' + item.instagramHandle"
                        v-if="selectedPlatform === 'tiktok'"
                      >@{{ item.instagramHandle }}</a>
                      <a
                        target="_blank"
                        v-bind:href="item.url"
                        v-else-if="selectedPlatform === 'youtube'"
                      >@{{ item.instagramHandle || item.fullName }}</a>
                      <a
                        target="_blank"
                        v-bind:href="'https://instagram.com/' + item.instagramHandle"
                        v-else
                      >@{{ item.instagramHandle }}</a>
                      <v-tooltip v-if="item.importedCreator" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="true" color="secondary" small v-on="on">mdi-newspaper-plus</v-icon>
                        </template>
                        <span>Imported Creator</span>
                      </v-tooltip>
                      <!-- <v-tooltip v-else bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="true" color="red" v-on="on">cancel</v-icon>
                        </template>
                        <span>Not in IMS</span>
                      </v-tooltip> -->
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.campaigns`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <div v-for="(campaignType, index) in item.campaignTypes" :key="index">
                        <v-chip
                          class="ma-2"
                          x-small
                          v-if="campaignType.count > 0"
                          @click="openCampaignListsModal(item, item.instagramHandle)"
                        ><subtitle-1>{{campaignType.name}}</subtitle-1> &nbsp;<b>({{campaignType.count}})</b></v-chip>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.totalFollowers`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.totalFollowers | thousandSeprator}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.country`]="{ item }">
                  <v-chip
                    v-if="!item.countries || item.countries.length === 0"
                    class="ma-2"
                    color="#ffffff"
                    x-small
                    text-color="black"
                    style="text-transform: capitalize;"
                  >{{'-'}}</v-chip>
                  <v-chip                                 
                    v-else                              
                    v-for="(country, index) in item.countries"
                    :key="index"
                    v-show="index === 0"
                    class="ma-2"
                    x-small             
                  >{{country.name}}</v-chip>                              
                  
                  <v-menu
                    v-show="item.countries"
                    :close-on-content-click="false"
                    top                                                 
                    offset-x                              
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="'btnMore_'+parentIndex"
                        v-show="item.countries && item.countries.length > 0"                       
                        color="secondary"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        text
                      >
                        More...
                      </v-btn>
                    </template>
                    <v-card max-width="300" style="text-align: left;">
                      <v-card-text>
                        <div>Countries</div>
                        <v-divider></v-divider>
                        <div
                        class="d-flex justify-space-between"
                        v-for="(country, index) in item.countries"
                        :key="index">                                    
                          <v-chip
                            class="ma-2"
                            x-small           
                          >{{country.name}}</v-chip>
                          <span class="more-percent">({{(country.weight * 100).toFixed(2)}}%)</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
                <template v-slot:[`item.genderPercentage`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <div style="width:75px;">
                        <PieChart
                          :name="`genderPie${item.id}`"
                          :title="genderPie.title"
                          :labels="genderPie.labels"
                          :backgroundColors="genderPie.backgroundColors"
                          :items="getGenderPieData(item.audienceGenders)"
                          :options="genderPie.options"
                          :width="genderPie.width"
                          :height="genderPie.height"
                          v-if="item.audienceGenders.length > 0"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.ageGroup`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      <div class="pa-2" style="max-width:84px!important;max-height:84px!important">
                        <bar-chart
                          :options="barChartOptions"
                          :chart-data="item.ageGroupDisplay"
                        />
                        <v-menu
                          v-show="item.audienceAges"
                          :close-on-content-click="false"
                          top                                                 
                          offset-x                              
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :id="'btnMore_'+parentIndex"
                              v-show="item.audienceAges && item.audienceAges.length > 0"                       
                              color="secondary"
                              x-small
                              dark
                              v-bind="attrs"
                              v-on="on"
                              text
                              style="margin-top: -25px;"
                            >
                              More...
                            </v-btn>
                          </template>
                          <v-card max-width="300" style="text-align: left;">
                            <v-card-text>
                              <div>Aud. Age Groups</div>
                              <v-divider></v-divider>
                              <div
                              class="d-flex justify-space-between"
                              v-for="(age, index) in getSortedAges(item.audienceAges)"
                              :key="index">                                    
                                <v-chip
                                  class="ma-2"
                                  x-small           
                                >{{age.code}}</v-chip>
                                <span class="more-percent">({{(age.weight * 100).toFixed(2)}}%)</span>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.creatorAgeGroup`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{item.ageGroup}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.engagements`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ parseInt(item.engagements) | abbr }}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.engagementRate`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.engagementRate }}%
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.paidPstPerformance`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.paidPstPerformance }}<span v-if="item.paidPstPerformance !== '-'">%</span>
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.audienceCredibility`]="{ item }">
                  <tr>
                    <td class="text-xs-left" v-if="selectedPlatform === 'instagram'">
                      <v-chip
                        style="width:50px"
                        class="ma-2"
                        x-small
                        :color="item.audienceCredibilityColor"
                        text-color="white"
                      ></v-chip>
                    </td>
                    <td class="text-xs-left" v-else>
                      {{ item.audienceCredibility }}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.rateCard`]="{ item }">
                  <v-menu
                    max-height="500px"             
                    :close-on-content-click="false"    
                    top                                                            
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn                                                  
                        color="secondary"
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        text
                        @click="getRateCard(item)"
                      >
                        View
                      </v-btn>
                    </template>
                    <v-card max-width="350" style="text-align: left;width:300px;">
                      <v-card-text>
                        <v-expansion-panels v-model="openExpansion" multiple>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <div>IMS Imported Rates <br><span style="font-size:10px;">(in SGD per item)</span></div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <rate-card-preview
                                :data="inputRates"
                                type="IMS"
                              />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <div>Rate Card Form Rates <br><span style="font-size:10px;">(in SGD per item)</span></div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <rate-card-preview
                                :data="rateCardFormRates"
                                type="rateCard"
                              />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
                <template v-slot:[`item.infInterests`]="{ item }">
                  <v-chip
                    v-if="!item.infInterests || item.infInterests.length === 0"
                    class="ma-2"
                    color="#ffffff"
                    x-small
                    text-color="black"
                    style="text-transform: capitalize;"
                  >{{'-'}}</v-chip>
                  <v-chip                                 
                    v-else                              
                    v-for="(interest, index) in item.infInterests"
                    :key="index"
                    v-show="index === 0"
                    class="ma-2"
                    x-small             
                  >{{interest.name}}</v-chip>                              
                  
                  <v-menu                                                            
                  v-show="item.infInterests"      
                  :close-on-content-click="false"    
                  top                                                 
                  offset-x                              
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="'btnMore_'+item.id"
                        v-show="item.infInterests && item.infInterests.length > 0"                       
                        color="secondary"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        text
                      >
                        More...
                      </v-btn>
                    </template>
                    <v-card max-width="300" style="text-align: left;">
                      <v-card-text>
                        <div>Influencer Interests</div>
                        <v-divider></v-divider>                                    
                        <v-chip                                      
                          v-for="(interest, index) in item.infInterests"
                          :key="index"
                          v-show="index !== 0"
                          class="ma-2"
                          small           
                        >{{interest.name}}</v-chip>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
                <template v-slot:[`item.audienceInterests`]="{ item }">
                  <v-chip
                    v-if="!item.audienceInterests || item.audienceInterests.length === 0"
                    class="ma-2"
                    color="#ffffff"
                    x-small
                    text-color="black"
                    style="text-transform: capitalize;"
                  >{{'-'}}</v-chip>
                  <v-chip                                 
                    v-else                              
                    v-for="(interest, index) in item.audienceInterests"
                    :key="index"
                    v-show="index === 0"
                    class="ma-2"
                    x-small             
                  >{{interest.name}}</v-chip>                              
                  
                  <v-menu                                                            
                  v-show="item.audienceInterests"
                  :close-on-content-click="false"
                  top
                  offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :id="'btnMore_'+parentIndex"
                        v-show="item.audienceInterests && item.audienceInterests.length > 0"                       
                        color="secondary"
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="on"
                        text
                      >
                        More...
                      </v-btn>
                    </template>
                    <v-card max-width="300" style="text-align: left;">
                      <v-card-text>
                        <div>Audience Interests</div>
                        <v-divider></v-divider>
                        <div
                        class="d-flex justify-space-between"
                        v-for="(interest, index) in item.audienceInterests"
                        :key="index">                                    
                          <v-chip
                            class="ma-2"
                            x-small           
                          >{{interest.name}}</v-chip>
                          <span style="more-percent">({{(interest.weight * 100).toFixed(2)}}%)</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
                <template v-slot:[`item.avgViews`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.avgViews | thousandSeprator}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.avgLikes`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.avgLikes | thousandSeprator}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.avgComments`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.avgComments | thousandSeprator}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.avgReelPlays`]="{ item }">
                  <tr>
                    <td class="text-xs-left">
                      {{ item.avgReelPlays | thousandSeprator}}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.medianEngagements`]="{ item }">
                  <tr>
                    <td class="text-xs-left" style="min-width:115px;">
                      <div class="clearfix">
                        <!-- progressbar -->
                        <ul id="progressbar">
                          <li
                          :class="{'active red-color': !eng.median && index <= item.influencerIndex && item.influencerIndex < item.medianIndex,
                          'active green-color': !eng.median && index <= item.influencerIndex && item.influencerIndex >= item.medianIndex,
                          'median': eng.median && item.influencerIndex < item.medianIndex,
                          'median green-color': eng.median && item.influencerIndex >= item.medianIndex}"
                          v-for="(eng, index) in item.medianEngagements"
                          :key="index">
                            <span v-if="eng.median">Median</span>
                          </li>
                        </ul>
                      </div>
                      <div>
                        <v-btn
                          x-small
                          text
                          color="secondary"
                          @click="openMedianEngModal(item)"
                        >
                          Details
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td class="text-xs-left">{{ props.item.totalFollowers | thousandSeprator}}</td>
                    <td class="text-xs-left">{{ props.item.engagementRate }}%</td>
                    <td class="text-xs-left">{{ props.item.audienceCredibility }}%</td>
                  </tr>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <tr>
                    <td class="justify-center layout px-0">
                      <!-- View audience data -->
                      <v-btn @click="showReport(item)" color="info" class="ims-action">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">assessment</v-icon>
                          </template>
                          <span>View Audience Data</span>
                        </v-tooltip>
                      </v-btn>
                      <!-- delete profile -->
                      <v-btn @click="deleteAud(item)" color="red" class="ims-action" v-if="!item.isIMS && isSuperAdminRole">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon small v-on="on">mdi-trash-can-outline</v-icon>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
        </v-col>
      </v-row>      
    </section>

    <!-- Audience data report modal -->
    <audience-data-report-modal
      v-model="viewAudienceDataDialog"
      :audienceData="audienceDataReport"
      @showLoadingEvent="showLoadingEvent"
    />

    <v-dialog
      v-model="showLoading"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text style="padding-top:10px;">
          Exporting your data.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isLoading"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text style="padding-top:10px;">
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <input
      type="file"
      accept=".xlsx"
      id="igBulkHandle"
      ref="igBulkHandle"
      style="display: none"
      @change="igHandleBulkUpload"
    />
    <loading
      :active.sync="importLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <campaign-lists-modal
      :items="viewCampaigns"
      :handle="viewHandle"
      :value="viewCampaignListsDialog"
      v-model="viewCampaignListsDialog"
    />
    <median-engagements-modal
      :items="viewMedianEngs"
      :handle="viewHandle"
      :engagementRate="viewEngRate"
      :followersRange="viewFollowersRange"
      :value="viewMedianEngDialog"
      v-model="viewMedianEngDialog"
    />
    <add-influencer-pairing-modal
      :selectedInfluencers="selectedLists"
      :value="addInfluencerPairingDialog"
      v-model="addInfluencerPairingDialog"
    />
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="All Influencers"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <!-- All Campaign Reports Passcode Modal -->
    <all-reports-passcode-modal
      :value="allReportsPasscodeDialog"
      v-model="allReportsPasscodeDialog"
      :reportType="downloadReportType"
      @success="reportPasscodeSuccess"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import config from '@/config';
import campaignConfig from '../Campaign/config'
import searchConfig from './searchConfig';
import influencerAPIs from './influencerAPIs';
import userAPIs from '../User/userAPIs';
// import campaignAPIs from '../Campaign/campaignAPIs'
import pairingAPIs from '../Pairing/pairingAPIs';
import AudienceDataReportModal from './AudienceDataReportModal';
import CampaignListsModal from './CampaignListsModal';
import MedianEngagementsModal from './MedianEngagementsModal';
import AddInfluencerPairingModal from './AddInfluencerPairingModal';
import AllReportsPasscodeModal from '../Campaign/AllCampaignsReport/AllReportsPasscodeModal';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import utils from '../../../utils';
import uniq from 'lodash/uniq';
import Loading from 'vue-loading-overlay';
import AudienceInterestsJSON from './iqdata_interests_response.json'
import PieChart from '@/components/chartjs/Pie';
import BarChart from '../../charts/BarChart.js';
import RateCardPreview from './RateCard/Preview.vue';
import orderBy from 'lodash/orderBy';
import countries from '../../../../static/sources/countries';

export default {
  name: 'influencer',
  components: {
    AudienceDataReportModal,
    CampaignListsModal,
    MedianEngagementsModal,
    AddInfluencerPairingModal,
    TableColsShowHideModal,
    AllReportsPasscodeModal,
    RateCardPreview,
    Loading,
    PieChart,
    BarChart
  },
  data() {
    return {
      audienceDataReport: null,
      allReportsPasscodeDialog: false,
      downloadReportType: null,
      barChartOptions: {
        barPercentage: 0.1,
        maxBarThickness: 'flex',
        categoryPercentage: 0.5,
        borderWidth: 0,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              display: false
            },
            gridLines: {
              display: false
            }
          }]
        }
      },
      sortBy: 'name',
      influencerGeos: 'Singapore', // new filter influencer
      audGeos: [], // new filter influencer
      audGeoPercent: '',
      audInterestPercent: '',
      search: null,
      expand: false, // Close other rows
      shouldCallApi: false,
      loading: false,
      isLoading: false,
      pagination: {
        // v-data-table pagination
        data: [],
        sortDesc: [true],
        page: 1,
        sortBy: ['audienceCredibility'],
        itemsPerPage: 15
      },
      totalItems: 0,
      rowsPerPageItems: [15, 30, 60, 100],
      postsTitle: '',
      avatarSize: 40, // avatar
      countries: [], // For filter influencer
      shortCodes: [],
      sortDesc: false,
      platforms: ['Instagram', 'Facebook'],
      selectedPlatform: 'instagram',
      openExpansion: [],
      inputRates: {},
      rateCardFormRates: {},
      searchFilter: searchConfig.searchFilters(),
      genderPie: {
        labels: ['MALE', 'FEMALE'],
        backgroundColors: ['rgba(66, 165, 244, 1)', 'rgba(239, 83, 80, 1)'],
        options: {
          responsive: true,
          legend: false,
          tooltips: {
            bodyFontSize: 8,
            position: 'average',
            xAlign: 'center',
            yAlign: 'center'
          }
        },
        width: 30,
        height: 30
      },
      audienceInterestLists: AudienceInterestsJSON.data.interests,
      platformList: [
        {
          text: 'Instagram',
          value: 'instagram'
        },
        {
          text: 'TikTok',
          value: 'tiktok'
        },
        {
          text: 'Youtube',
          value: 'youtube'
        }
      ],
      fields: [
        {
          value: 'profilePicture',
          text: 'Avatar',
          sortable: false,
          profilePicture: true
        },
        {
          value: 'instagramHandle',
          text: 'Handle',
          sortable: false,
          instagramHandle: true
        },
        {
          value: 'campaigns',
          text: 'Campaigns',
          sortable: false,
          campaigns: true
        },
        {
          value: 'totalFollowers',
          text: 'Followers',
          totalFollowers: true
        },
        {
          value: 'engagementRate',
          text: 'Eng. Rate',
          sortable: false,
          engagementRate: true
        },
        {
          value: 'audienceCredibility',
          text: 'Aud. Credibility',
          sortable: false,
          audienceCredibility: true
        },
        {
          value: 'gender',
          text: 'Gender',
          sortable: false,
          gender: true
        },
        {
          value: 'genderPercentage',
          text: 'Aud. Gender',
          sortable: false,
          genderPercentage: true
        },
        {
          value: 'ageGroup',
          text: 'Aud. Age Group',
          sortable: false,
          ageGroup: true
        },
        {
          value: 'creatorAgeGroup',
          text: 'Age Group',
          sortable: false,
          creatorAgeGroup: true
        },
        {
          value: 'country',
          text: 'Aud. Country',
          sortable: false,
          country: false
        },
        // {
        //   value: 'engagements',
        //   text: 'Engagements',
        //   sortable: false
        // },
        {
          value: 'paidPstPerformance',
          text: 'Paid Post Performance',
          sortable: false,
          engagementRate: true
        },
        {
          value: 'rateCard',
          text: 'Rate Card',
          sortable: false,
          rateCard: false
        },
        {
          text: 'Influencer interests',
          sortable: false,
          value: 'infInterests',
          name: 'infInterests',
          infInterests: false
        },
        {
          text: 'Audience interests',
          sortable: false,
          value: 'audienceInterests',
          name: 'audienceInterests',
          audienceInterests: false
        },
        {
          text: 'Median Engagement',
          sortable: false,
          value: 'medianEngagements',
          name: 'medianEngagements',
          medianEngagements: false
        },
        {
          text: 'Avg Views',
          sortable: true,
          value: 'avgViews',
          avgViews: false
        },
        {
          text: 'Avg Likes',
          sortable: true,
          value: 'avgLikes',
          avgLikes: false
        },
        {
          text: 'Avg Comments',
          sortable: true,
          value: 'avgComments',
          avgComments: false
        },
        {
          text: 'Avg Reel Plays',
          sortable: true,
          value: 'avgReelPlays',
          avgReelPlays: false
        },
        // {
        //   value: 'created',
        //   text: 'Created',
        //   sortable: false
        // },
        {
          value: 'action',
          text: 'Actions',
          action: true
        }
      ],
      // Setting search influencer by keyword
      negativeKeyword: '',
      negativePeriod: 'entire_account',
      optInOnly: false,
      searchDuration: 12,
      searchNlu: true,
      computerVison: true,
      dialog: false,
      items: [],
      users: [],
      pairings: [],
      filterCampaigns: [],
      viewCampaigns: [],
      viewMedianEngs: [],
      viewHandle: '',
      viewEngRate: '',
      viewFollowersRange: {},
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      keyword: '',
      fromAge: '',
      toAge: '',
      fromFol: '',
      toFol: '',
      fromEng: '',
      toEng: '',
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      selectedLists: [],
      searchFilterLists: [],
      selectedCountries: ['all'],
      audCredibilities: [
        '#4caf50',
        '#f9a825',
        '#f44336'
      ],
      colSettingsDialog: false,
      colStatuses: {},
      userProfile: {},
      resultMessage: '',
      monthPicker: false,
      showLoading: false,
      importLoading: false,
      viewCampaignListsDialog: false,
      viewMedianEngDialog: false,
      addInfluencerPairingDialog: false,
      audienceFollowersGenderPerAge: null,
      searchConfig
    };
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns,
      rateCards: state => state.influencer.rateCards,
      deletedAud: state => state.influencer.deletedAud
    }),
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isAdminRole: function () {
      const role = Number(this.$store.state.user.role)
      return role === config.userRoles.SUPER_ADMIN_HIGH || role === config.userRoles.SUPER_ADMIN_LOW || role === config.userRoles.COMPANY_ADMIN_LOW || role === config.userRoles.COMPANY_ADMIN_HIGH
    },
    isSuperAdminRole: function () {
      const role = Number(this.$store.state.user.role)
      return role === config.userRoles.SUPER_ADMIN_HIGH || role === config.userRoles.SUPER_ADMIN_LOW
    },
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow();
    },
    createModalIdDisplay: function() {
      return '#' + this.createModalId;
    },
    editModalIdDisplay: function() {
      return '#' + this.editModalId;
    },
    viewCompanyModalIdDisplay: function() {
      return '#' + this.viewCompanyModalId;
    },
    influencerPostDisplay: function() {
      return '#' + this.influencerPostModalId;
    },
    availableCountries() {
      // extract the available countries
      return uniq(this.searchedItems.map(item => item.country));
    },
    payload() {
      // let audienceInterest = this.searchFilter.audienceInterest.map(i => i.name)
      let infInterest = this.searchFilter.infInterest
      return {
        filter: {
          geo: this.influencerGeos,
          audience_geo: this.audGeos,
          audienceGeoPercent: this.audGeoPercent,
          audInterestPercent: this.audInterestPercent,
          igHandle: this.igHandle,
          platform: this.selectedPlatform,
          gender: this.searchFilter.gender,
          campaign: this.searchFilter.campaign,
          followers: this.searchFilter.followers,
          ageGroup: this.searchFilter.ageGroup,
          ageGroupPercent: this.searchFilter.ageGroupPercent,
          secAgeGroup: this.searchFilter.secAgeGroup,
          secAgeGroupPercent: this.searchFilter.secAgeGroupPercent,
          limit: this.searchFilter.limit,
          // ageGroupLimit: this.searchFilter.ageGroupLimit,
          // countryLimit: this.searchFilter.countryLimit,
          // audInterestLimit: this.searchFilter.audInterestLimit,
          credibility: this.searchFilter.credibility,
          engagements: this.searchFilter.engagements,
          engagementRate: this.searchFilter.engagementRate,
          paidPstPerformance: this.searchFilter.paidPstPerformance,
          isIMS: this.searchFilter.isIMS,
          audience_interests: this.searchFilter.audienceInterest,
          inf_interests: infInterest,
          campaignType: this.searchFilter.campaignType
        },
        paging: {
          per_page: this.pagination.itemsPerPage <= 0 ? 20 : this.pagination.itemsPerPage,
          page: 1,
          sortBy: this.pagination.sortBy[0],
          descending: this.pagination.sortDesc[0]
        }
      };
    },
    computedHeaders() {
      let allInfsCols = null
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.allInfsCols) {
          allInfsCols = Object.assign({}, this.userProfile.tableSettings.allInfsCols)
        }
      }
      if (allInfsCols) {
        this.colStatuses = Object.assign({}, allInfsCols)
      } else {
        // set defaults if no col status
        this.fields.map(header => {
          this.colStatuses[header.value] = header[header.value]
        })
      }
      return this.fields.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    getFilterLists() {
      let type = ''
      type = 'mainCountry'
      if (this.influencerGeos) {
        if (this.influencerGeos.length) {
          let retData = {
            type,
            title: 'Country',
            icon: 'mdi-account',
            value: this.influencerGeos
          }
          this.setFilterItem(type, retData)
        } else {
          this.removeItemFromFilterList(type)
        }
      } else {
        this.removeItemFromFilterList(type)
      }
      // gender filter
      type = 'gender'
      let genderRet = this.genderFilter
      if (genderRet) {
        let retData = {
          type,
          title: 'Gender',
          icon: 'mdi-account',
          value: genderRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // ims status filter
      type = 'isIMS'
      let isIMS = this.imsFilter
      if (isIMS) {
        let retData = {
          type,
          title: 'IMS Status',
          icon: 'mdi-account',
          value: isIMS
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // campaigns filter
      let campaign = this.campaignFilter
      type = 'campaign'
      if (this.campaignFilter) {
        let retData = {
          type,
          title: 'Campaign',
          icon: 'mdi-bullhorn',
          value: campaign
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // aud credibility filter
      let audCred = this.audCredibilityFilter
      type = 'audCredibility'
      if (audCred) {
        let retData = {
          type,
          title: 'Aud. Credibility',
          icon: 'mdi-account-multiple',
          htmlValue: audCred
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // aud geo filter
      let audGeo = this.countryFilter
      type = 'audGeo'
      if (audGeo) {
        let retData = {
          type,
          title: 'Aud. Country',
          icon: 'mdi-account-multiple',
          value: audGeo
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // follower filter
      let followerRet = this.followerFilter
      type = 'followers'
      if (followerRet) {
        let retData = {
          type,
          title: 'Followers',
          icon: 'mdi-account-multiple',
          value: followerRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // age group filter
      let ageGroupRet = this.ageGroupFilter
      type = 'ageGroup'
      if (ageGroupRet) {
        let retData = {
          type,
          title: 'Age Group',
          icon: 'mdi-account-multiple',
          value: ageGroupRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // inf interests filter
      let infInterestsRet = this.infInterestsFilter
      type = 'infInterests'
      if (infInterestsRet) {
        let retData = {
          type,
          title: 'Influencer Interests',
          icon: 'mdi-account',
          value: infInterestsRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // aud interests filter
      let audInterestsRet = this.audInterestsFilter
      type = 'audInterests'
      if (audInterestsRet) {
        let retData = {
          type,
          title: 'Aud. Interests',
          icon: 'mdi-account-multiple',
          value: audInterestsRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // eng.rate filter
      let engRateRet = this.engRateFilter
      type = 'engRate'
      if (engRateRet) {
        let retData = {
          type,
          title: 'Eng. Rate',
          icon: 'mdi-bullhorn',
          value: engRateRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      // paid pst filter
      let paidPstRet = this.paidPstFilter
      type = 'paidPstRet'
      if (paidPstRet) {
        let retData = {
          type,
          title: 'Paid Post Performance',
          icon: 'mdi-bullhorn',
          value: paidPstRet
        }
        this.setFilterItem(type, retData)
      } else {
        this.removeItemFromFilterList(type)
      }
      return this.searchFilterLists
    },
    mainCountryFilter() {
      let ret = ''
      if (this.influencerGeos) {
        if (this.influencerGeos.length) {
          ret = this.influencerGeos
        }
      }
      return ret
    },
    genderFilter() {
      let ret = ''
      if (this.searchFilter.gender) {
        ret = this.searchFilter.gender
      }
      return ret
    },
    imsFilter() {
      let ret = ''
      if (this.searchFilter.isIMS) {
        let matchOption = this.searchConfig.imsOptions.find(p => p.value === this.searchFilter.isIMS)
        if (matchOption) {
          ret = matchOption.text
        }
      }
      return ret
    },
    countryFilter() {
      let ret = ''
      if (this.audGeos.length) {
        ret += this.audGeos.join(',') + ' '
      }
      if (this.audGeoPercent) {
        ret += this.audGeoPercent
      }
      return ret
    },
    followerFilter() {
      let ret = ''
      if (this.searchFilter.followers.from || this.searchFilter.followers.to) {
        ret += 'Followers '
      }
      if (this.searchFilter.followers.from && this.searchFilter.followers.to) {
        ret += `${this.searchFilter.followers.from}-${this.searchFilter.followers.to}`
      } else if (this.searchFilter.followers.from) {
        ret += `${this.searchFilter.followers.from}+`
      } else if (this.searchFilter.followers.to) {
        ret += `Up to ${this.searchFilter.followers.to}`
      }
      return ret
    },
    ageGroupFilter() {
      let ret = ''
      if (this.searchFilter.ageGroup) {
        ret += this.searchFilter.ageGroup + ' '
      }
      if (this.searchFilter.ageGroupPercent) {
        ret += `(${this.searchFilter.ageGroupPercent}) `
      }
      if ((this.searchFilter.ageGroup || this.searchFilter.ageGroupPercent) &&
      (this.searchFilter.secAgeGroup || this.searchFilter.secAgeGroupPercent)) {
        ret += ', '
      }
      if (this.searchFilter.secAgeGroup) {
        ret += this.searchFilter.secAgeGroup + ' '
      }
      if (this.searchFilter.secAgeGroupPercent) {
        ret += `(${this.searchFilter.secAgeGroupPercent})`
      }
      return ret
    },
    infInterestsFilter() {
      let ret = ''
      if (this.searchFilter.infInterest) {
        let matchInterests = this.audienceInterestLists.filter(ai => this.searchFilter.infInterest.includes(ai.id))
        if (matchInterests) {
          ret += matchInterests.map(i => i.name).join(',')
        }
      }
      return ret
    },
    audInterestsFilter() {
      let ret = ''
      if (this.searchFilter.audienceInterest) {
        ret += this.searchFilter.audienceInterest.join(',')
      }
      if (this.audInterestPercent) {
        ret += ` ${this.audInterestPercent} `
      }
      return ret
    },
    engRateFilter() {
      let ret = ''
      if (this.searchFilter.engagementRate.to) {
        ret += `Eng. Rate Up to ${this.searchFilter.engagementRate.to}%`
      }
      return ret
    },
    paidPstFilter() {
      let ret = ''
      if (this.searchFilter.paidPstPerformance.from || this.searchFilter.paidPstPerformance.to) {
        ret += 'Paid Pst. Performance '
      }
      if (this.searchFilter.paidPstPerformance.from && this.searchFilter.paidPstPerformance.to) {
        ret += `${this.searchFilter.paidPstPerformance.from}%-${this.searchFilter.paidPstPerformance.to}%`
      } else if (this.searchFilter.paidPstPerformance.from) {
        ret += `${this.searchFilter.paidPstPerformance.from}%+`
      } else if (this.searchFilter.paidPstPerformance.to) {
        ret += `Up to ${this.searchFilter.paidPstPerformance.to}%`
      }
      return ret
    },
    campaignFilter() {
      let ret = ''
      if (this.searchFilter.campaign) {
        let matchCampaign = this.filterCampaigns.find(f => f.id === this.searchFilter.campaign)
        if (matchCampaign) {
          ret += matchCampaign.name
        }
      }
      return ret
    },
    audCredibilityFilter() {
      let ret = ''
      if (this.searchFilter.credibility) {
        ret += `<div
                style="width: 50px;
                height: 10px;
                background: ${this.searchFilter.credibility};
                border-radius: 5px;"
              ></div>`
      }
      return ret
    },
    showFilters() {
      return this.getFilterLists.length > 0
    }
  },
  watch: {
    pagination(newVal) {
      if (this.shouldCallApi) {
        this.paginate(newVal.page);
      }
    }
  },
  methods: {
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    getCountries() {
      // Retrieve countries manually
      this.countries = countries
      this.countries = this.countries.map(c => c.name)
      // influencerAPIs.getCountries().then(countries => {
      //   this.countries = countries.map(item => item.name);
      // });
    },
    updateItems(response) {
      const displayItems = response.influencers.map(element => {
        let country = this.getCountryName(element)
        let audienceCredibility = this.selectedPlatform === 'instagram' ? (element.audience_followers && element.audience_followers.success
                ? Number(element.audience_followers.data.audience_credibility * 100).toFixed(2)
                : 0) : '-'
        let audienceData = element.audience_followers.data
        return Object.assign(
          { id: element._id || element.id },
          {
            reportID: element.report_info.report_id,
            instagramHandle: element.user_profile ? element.user_profile.username : null,
            fullName: element.user_profile ? element.user_profile.fullname : null,
            url: element.user_profile ? element.user_profile.url : null,
            platform: this.selectedPlatform,
            isIMS: element.isIMS || null,
            importedCreator: element.importedCreator || null,
            influencerID: element.influencerID || null,
            instagramID: element.user_profile ? element.user_profile.user_id : null,
            instagramFullname: element.user_profile ? element.user_profile.username : null,
            totalFollowers: element.user_profile ? element.user_profile.followers : 0,
            profilePicture: element.user_profile ? element.user_profile.picture : '/static/img/avatar/user.png',
            engagements:
              element.user_profile
                ? (Number(element.user_profile.engagements) * 100).toFixed(2)
                : 0,
            engagementRate:
              element.user_profile
                ? (Number(element.user_profile.engagement_rate) * 100).toFixed(2)
                : 0,
            paidPstPerformance:
              element.user_profile
                ? (element.user_profile.paid_post_performance ? (Number(element.user_profile.paid_post_performance) * 100).toFixed(2) : '-')
                : 0,
            gender: element.user_profile.gender,
            audienceCredibility,
            audienceCredibilityColor: utils.func.getCredibilityColor(audienceCredibility),
            audienceInterests: (audienceData.audience_interests ? audienceData.audience_interests : null),
            infInterests: element.user_profile
                ? element.user_profile.interests
                : null,
            audienceGenders: (audienceData.audience_genders ? audienceData.audience_genders : []),
            audienceGendersPerAge: (audienceData.audience_genders_per_age ? audienceData.audience_genders_per_age : []),
            audienceAges: (audienceData.audience_ages ? audienceData.audience_ages : []),
            ageGroup: element.user_profile.age_group,
            country: (country !== null ? country[0].name : country),
            countries: (audienceData.audience_geo ? audienceData.audience_geo.countries : []),
            avgViews: element.user_profile.avg_views || 0,
            avgLikes: element.user_profile.avg_likes || 0,
            avgComments: element.user_profile.avg_comments || 0,
            avgReelPlays: element.user_profile.avg_reels_plays || 0,
            followersRange: element.extra ? (element.extra.followers_range || {}) : {},
            medianEngagements: element.extra ? (element.extra.engagement_rate_histogram || []) : [],
            ageGroupChart: {
              labels: [],
              datasets: []
            }
            // created: this.formatDateTime(element.report_info.created)
          }
        )
      });
      this.items = displayItems;
      this.items = this.items.map(item => {
        item.medianEngagements = this.calculateMedians(item.medianEngagements, item.engagementRate, item.instagramHandle);
        item.influencerIndex = item.medianEngagements.findIndex(i => i.handle)
        item.medianIndex = item.medianEngagements.findIndex(i => i.median)
        item.ageGroupDisplay = this.createChartDataAudienceGendersPerAge(item)
        return item
      })
      this.getTopFiveAudienceInterests(this.items)
      this.totalRows = response.totalInfluencers;
      // store the searched results for Filtering
      this.searchedItems = displayItems;
    },
    getCountryName(element) {
      let country = ''
      let audienceData = element.audience_followers.data
      let countries = (audienceData.audience_geo ? audienceData.audience_geo.countries : null)
      // console.log("🚀 ~ file: PairingController.js ~ line 681 ~ crawlInfluencerDetail ~ countries", countries)
      if (countries !== null) {
        if (countries.length > 0) {
          // country = audience_data.audience_geo.countries.filter(item => Math.max(Math.round(item.weight)))
          country = countries.filter(item => {
            return item.weight === Math.max(...countries.map(w => w.weight), 0)
          })
        } else {
          country = null
        }
      } else {
        country = null
      }
      return country
    },
    paginate(page = 1) {
      this.currentPage = page;
      this.payload.paging.page = page;
      this.importLoading = true;
      influencerAPIs
        .localAllAudienceData(this.payload)
        .then(response => {
          this.updateItems(response);
          // this.pagination.data = response.influencers
          this.resultMessage = `Showing [` + this.perPage + `] per page of total [` + this.totalRows + `] influencers result.`;
          this.totalItems = this.totalRows;
          if (this.pagination.itemsPerPage === -1) {
            this.pagination.itemsPerPage = 20;
          }
          this.shouldCallApi = true;
          this.importLoading = false;
          this.selectedLists = []
          this.setCampaignTypes()
        })
        .catch(error => {
          this.importLoading = false;
          console.log(error);
        });
    },

    paserImageUrl(url) {
      if (!url) return '';
      var newUrl = url
        .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
        .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },

    showReport(influencer) {
      this.importLoading = true
      influencerAPIs
        .fetchLocalAudienceReport(influencer.id, influencer.instagramID, influencer.instagramHandle, this.selectedPlatform)
        .then(resp => {
          this.audienceDataReport = resp.data;
          this.viewAudienceDataDialog = true;
          this.importLoading = false
        })
        .catch(err => {
          console.error(err);
        });
    },
    editInfluencer(influencerData) {
      // Update the edited content to user
      var selectedIndex = -1;

      this.items.forEach(function(influencer, index) {
        if (influencer.id === influencerData.id) {
          selectedIndex = index;
          return;
        }
      });

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, influencerData);
      }

      // Do anything like highlighting the edited item
      console.log('influencer edited');
      this.getUsers()
    },
    exportInfluencers() {
      this.showLoading = true
      influencerAPIs
        .exportNonIMSInfluencersByFilter(this.payload)
        .then(response => {
          // commented old download method
          // const url = window.URL.createObjectURL(new Blob([response]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', `influencers_${moment().format('X')}.csv`);
          // document.body.appendChild(link);
          // link.click();
          this.showLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.showLoading = false;
        });
    },
    // Filter the result
    filterItems() {
      // iniitalize default values if the value is null
      let minAge = !this.fromAge ? 0 : this.fromAge;
      let maxAge = !this.toAge ? 150 : this.toAge;
      let minFol = !this.fromFol ? 0 : this.fromFol;
      let maxFol = !this.toFol ? 1000000000 : this.toFol;
      let minEng = !this.fromEng ? 0 : this.fromEng;
      let maxEng = !this.toEng ? 100 : this.toEng;
      let gender = this.filGender === 2 ? 'both' : this.filGender;
      let handle = this.igHandle;
      let countries = this.selectedCountries;

      let filteredItems = [];
      this.searchedItems.forEach(function(item, index) {
        // calculate the age
        let today = moment().format('YYYY');
        let bd = moment(item.birthday).format('YYYY');
        let age = today - bd;

        // handle the multiple country selection
        let countryStatus = false;
        countries.map(cnty => {
          if (cnty === item.country || cnty === 'all') {
            countryStatus = true;
          }
        });

        // for each match cases
        if (
          minAge <= age &&
          maxAge >= age &&
          minFol <= item.totalFollowers && maxFol >= item.totalFollowers &&
          minEng <= item.engagementRate && maxEng >= item.engagementRate &&
          (gender === item.gender || gender === 'both') &&
          countryStatus &&
          item.instagramHandle &&
          (item.instagramHandle.includes(handle) || handle === '')
        ) {
          filteredItems.push(item);
        }
      });
      // put the filtered results into the table
      this.items = filteredItems;
      this.resultMessage = `Showing (Filtered Influencers) based on your searched results.`;
    },
    async igHandleBulkUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      let handles = await new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = (e) => {
          const tmp = utils.func.parserToJson(e.target.result);
          resolve(tmp)
        };
        fr.readAsArrayBuffer(e.target.files[0]);
        fr.onerror = reject;
      });
      let handleItems = []
      for (const items of handles) {
        for (const record of items) {
          if (record.Instagram ||
          record.TikTok ||
          record.Youtube) {
            let preferredCampaigns = []
            if (record['Preferred Campaigns']) {
              preferredCampaigns = record['Preferred Campaigns'].split(',')
            }
            preferredCampaigns = preferredCampaigns.map(p => p.trim())
            handleItems.push({
              instagram: record['Instagram'],
              tiktok: record['TikTok'],
              youtube: record['Youtube'],
              name: record['Name'],
              followers: record['Followers'],
              gender: record['Gender'],
              country: record.Country.trim(),
              type: (record['Type'].trim()).toLowerCase(),
              agencyName: record['Agency Name'] || '',
              preferredCampaigns,
              aboutYou: record['About You'] || '',
              story: record['story'] || '',
              post: record['post'] || '',
              tiktokCount: record['Tiktok'] || '',
              carousel: record['carousel'] || '',
              sixtyReel: record['60s Reel'] || '',
              oneEightyReel: record['180s Reel'] || '',
              livestreamIntegration: record['Livestream integration'] || '',
              livestreamEpisode: record['livestream episode buy'] || '',
              dedicatedVideo: record['dedicated video post 5-10 minutes'] || '',
              youtubeIntegration: record['youtube video integration'] || '',
              youtubeEpisode: record['youtube episode buy'] || '',
              genre: record['Genre'] || '',
              loadingFee: record['Loading Fee'] || '',
              eventAppearance: record['Event Apperance'] || '',
              digitalUsage: record['Digital Usage Rights'] || '',
              photoShoot: record['Photo Shoot'] || ''
            })
          }
        }
      }
      this.uploadBulkHandle(handleItems)
    },
    uploadBulkHandle(handleItems) { // handleItems : array
      this.importLoading = true
      if (handleItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Influencer Handle Found'
        });
        return;
      }
      // let formData = new FormData()
      // formData.append('handles', JSON.stringify(handleItems))
      let data = Object.assign({}, {
        handleItems
      })
      influencerAPIs
      .importInfluencers(data)
      .then(resp => {
        this.importLoading = false
        // if (resp.failedInfluencers !== undefined && resp.failedInfluencers.length > 0) {
        //   this.showFailedImportAlert(resp.failedInfluencers)
        //   return false
        // }
        this.$swal({
          title: 'Success',
          icon: 'info',
          text: `Successfully Imported.`
        });
        this.paginate(this.currentPage)
      })
      .catch(err => {
        this.importLoading = false
        console.error(err);
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Failed to Import Influencers`
        });
      });
      this.$refs.igBulkHandle.value = null;
    },
    showFailedImportAlert(failedInfluencers) {
      if (failedInfluencers.length > 0) { // if already selected exists, show after completed
        let displayBlock = ''
        failedInfluencers.map(a => {
          displayBlock += `<span class="v-chip theme--light v-size--default" style="font-weight:bold;margin:5px;background:red;color:#fff">
            <span class="v-chip__content">${a.handle}</span>
          </span>`
        })
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Influencers failed to import: <div>${displayBlock}</div>`
        });
      }
      return;
    },
    resetFilters() {
      // reset into initial state for filters
      this.fromAge = '';
      this.toAge = '';
      this.fromFol = '';
      this.toFol = '';
      this.fromEng = '';
      this.toEng = '';
      this.filGender = 'Any';
      this.igHandle = '';
      this.influencerGeos = [];
      this.audGeos = [];
      this.audGeoPercent = ''
      this.audInterestPercent = ''
      this.searchFilter = searchConfig.searchFilters()
      this.paginate(this.currentPage);
    },
    reloadAll() {
      // reset to default
      this.currentPage = 1;
      this.perPage = 15;
      this.keyword = '';
      this.igHandle = '';
      this.joinedMonth = '';
      this.resetFilters();
    },
    remove(item) {
      this.influencerGeos.splice(this.influencerGeos.indexOf(item), 1);
      this.influencerGeos = [...this.influencerGeos];
    },
    removeAudGeos(item) {
      this.audGeos.splice(this.audGeos.indexOf(item), 1);
      this.audGeos = [...this.audGeos];
    },
    removeInfInterest(item) {
      this.searchFilter.infInterest.splice(this.searchFilter.infInterest.indexOf(item), 1);
      this.searchFilter.infInterest = [...this.searchFilter.infInterest];
    },
    removeAudInterest(item) {
      this.searchFilter.audienceInterest.splice(this.searchFilter.audienceInterest.indexOf(item), 1);
      this.searchFilter.audienceInterest = [...this.searchFilter.audienceInterest];
    },
    joinedMonthOk() {
      this.$refs.monthPicker.save(this.joinedMonth)
      this.paginate(this.currentPage)
    },
    async getUsers() {
      // Get all Influencers User Data by role
      let response = await userAPIs.getAllUsersByRole(config.userRoles.INFLUENCER)
      if (response) {
        this.users = response.users
      }
    },
    formatDateTime(value) {
      return moment(value).format('MMM DD, YYYY hh:mm:ss');
    },
    getTopFiveAudienceInterests(items) {
      for (let item of items) {
        if (item.audienceInterests) {
          item.audienceInterests = item.audienceInterests.sort((a, b) => b.weight - a.weight).slice(0, 5)
        }
      }
    },
    getGenderPieData(audienceGenders) {
      if (Array.isArray(audienceGenders)) {
        let ret = []
        let male = audienceGenders.find(a => a.code === 'MALE')
        if (male) ret.push(male)
        let female = audienceGenders.find(a => a.code === 'FEMALE')
        if (female) ret.push(female)
        return ret.map(gender => (gender.weight * 100).toFixed(2))
      }
    },
    async setCampaignTypes() {
      // load campaigns, and pairings if not set
      if (this.pairings.length === 0) {
        this.pairings = await pairingAPIs.getAllPairings()
        // filter for accepted only pairings
        this.pairings = this.pairings.filter(p => p.pairing_details && p.pairing_details.status === config.pairingStatus.ACCEPTED)
      }
      // if (this.campaigns.length === 0) {
      //   this.campaigns = await campaignAPIs.getAllCampaignsNoStatus()
      // }
      for (let item of this.items) {
        let campaignIDs = await this.getInfCampaignIDs(item)
        let influencerCampaigns = this.campaigns.filter(campaign => campaignIDs.includes(campaign.id))
        item.campaignTypes = await this.getInfCampaignTypes(influencerCampaigns)
      }
      this.items = Object.assign([], this.items)
    },
    async getInfCampaignIDs(item) {
      let infPairings = this.pairings.filter(pairing => {
        let influencerDetails = pairing.influencer_details
        if (influencerDetails && influencerDetails.instagramHandle === item.instagramHandle) {
          if (this.platform === 'tiktok') {
            if (influencerDetails.platform === 'tiktok') {
              return true
            }
          } else return true
        }
        return false
      })
      let campaignIDs = infPairings.map(p => p.campaignID)
      return campaignIDs
    },
    async getInfCampaignTypes(influencerCampaigns) {
      let campaignTypes = this.getCampaignTypes()
      let naIndex = campaignTypes.findIndex(type => type.value === -1)
      influencerCampaigns.map(infCampaign => {
        let matchIndex = campaignTypes.findIndex(type => infCampaign.campaignType && type.value === infCampaign.campaignType)
        if (matchIndex !== -1) {
          campaignTypes[matchIndex].campaigns.push(infCampaign)
          campaignTypes[matchIndex].count += 1
        } else {
          campaignTypes[naIndex].campaigns.push(infCampaign)
          campaignTypes[naIndex].count += 1
        }
      })
      return campaignTypes
    },
    getCampaignTypes() {
      let types = campaignConfig.campaignTypeDisplay.map(type =>
        Object.assign({}, {
          name: type.text,
          value: type.value,
          count: 0,
          campaigns: []
        })
      )
      types.push({
        name: 'Others',
        value: -1,
        count: 0,
        campaigns: []
      })
      return types
    },
    calculateMedians(medians, engagementRate, handle) {
      medians = medians.map(item => {
        item.min = item.min ? (Number(item.min) * 100).toFixed(2) : -1
        item.max = item.max ? (Number(item.max) * 100).toFixed(2) : -1

        if (engagementRate >= Number(item.min) && engagementRate <= Number(item.max)) {
          item.handle = handle
        }
        item.rate = ''
        if (item.min === -1 && item.max >= 0) {
          item.rate += `< ${item.max}%`
        } else if (item.max === -1 && item.min >= 0) {
          item.rate += `> ${item.min}%`
        } else if (item.max > 0 && item.min >= 0) {
          item.rate += `${item.min}% - ${item.max}%`
        }
        return item
      })
      return medians
    },
    openCampaignListsModal(item, handle) {
      this.viewHandle = handle
      this.viewCampaigns = []
      item.campaignTypes.map(type => {
        this.viewCampaigns.push(...type.campaigns)
      })
      this.setShowCampaignVerticals()
      this.viewCampaignListsDialog = true
    },
    setShowCampaignVerticals() {
      this.viewCampaigns = this.viewCampaigns.map(v => {
        if (v.vertical && v.vertical.length > 0) {
          v.showVerticals = v.vertical.map(vt => vt.name).join(', ')
        } else {
          v.showVerticals = '-'
        }
        return v
      })
    },
    openMedianEngModal(item) {
      this.viewHandle = item.instagramHandle
      this.viewEngRate = item.engagementRate
      this.viewFollowersRange = item.followersRange
      this.viewMedianEngs = item.medianEngagements
      this.viewMedianEngDialog = true
    },
    openAddPairingCampaignModal() {
      this.addInfluencerPairingDialog = true
    },
    async getRateCard(item) {
      let influencerID = item.influencerID
      this.inputRates = {}
      if (influencerID) {
        influencerAPIs.getInfluencer(influencerID).then(item => {
          this.inputRates = item.inputedRates || {}
          if (this.inputRates.pricingDecks && this.inputRates.pricingDecks.length === 0) {
            this.isPricingDeskEmpty = true
          }
        })
      }
      await this.getRateCardFormLists(item)
    },
    async getRateCardFormLists(item) {
      this.rateCardFormRates = {}
      let filters = {}
      if (item.platform) {
        if (item.platform === 'tiktok') {
          filters.tiktokHandle = item.instagramHandle
        } else {
          filters.instagramHandle = item.instagramHandle
        }
      } else filters.instagramHandle = item.instagramHandle
      await this.$store.dispatch('influencer/getRateCardLists', { filters })
      if (this.rateCards && this.rateCards.length > 0) {
        this.rateCardFormRates = this.rateCards[0]
      }
    },
    showLoadingEvent(status) {
      this.importLoading = status
    },
    downloadSampleUpload() {
      var link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_creator_bulkupload.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.fields.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.fields)) {
        this.tableColsItems.push({
          title: value.text,
          key: value.value,
          value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
        })
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.allInfsCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    createChartDataAudienceGendersPerAge(item) {
      let audienceGendersPerAge = item.audienceGendersPerAge;
      let audienceGendersPerAgeMale = {
        label: 'Male',
        backgroundColor: '#42a5f5',
        data: []
      };
      let audienceGendersPerAgeFemale = {
        label: 'Female',
        backgroundColor: '#ff595e',
        data: []
      };
      for (let data of audienceGendersPerAge) {
        audienceGendersPerAgeMale.data.push((data.male * 100).toFixed(2));
        item.ageGroupChart.labels.push(data.code);
      }
      for (let data of audienceGendersPerAge) {
        audienceGendersPerAgeFemale.data.push((data.female * 100).toFixed(2));
      }
      item.ageGroupChart.datasets.push(audienceGendersPerAgeMale);
      item.ageGroupChart.datasets.push(audienceGendersPerAgeFemale);
      return item.ageGroupChart
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    openReportPasscodeDialog() {
      this.allReportsPasscodeDialog = true
    },
    reportPasscodeSuccess() {
      this.exportInfluencers()
    },
    refreshReport(item) {
      this.isLoading = true
      let reportId = item.reportID;
      influencerAPIs.refreshAudienceReport(reportId).then(data => {
        this.isLoading = false
        this.paginate(this.currentPage)
      });
    },
    selectAllLists($event) {
      if (!$event.value) {
        this.selectedLists = [];
        return;
      }
      this.selectedLists = Object.assign([], this.items);
    },
    deleteAud(item) {
      this.$swal({
        title: 'Confirm',
        text: 'Are you sure to delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let payload = {
            id: item.id,
            platform: this.selectedPlatform
          }
          await this.$store.dispatch('influencer/deleteAud', payload)
          if (this.deletedAud) {
            this.$swal({
              title: 'Successfully Deleted!',
              type: 'success'
            });
            this.paginate()
          }
        }
      })
    },
    getSortedAges(ages) {
      if (Array.isArray(ages)) {
        if (ages.length) {
          return orderBy(ages, ['weight'], ['desc'])
        }
      }
      return ages
    },
    removeFilterShow(type) {
      if (type === 'mainCountry') {
        this.influencerGeos = []
      }
      if (type === 'gender') {
        this.searchFilter.gender = ''
      }
      if (type === 'isIMS') {
        this.searchFilter.isIMS = 0
      }
      if (type === 'campaign') {
        this.searchFilter.campaign = ''
      }
      if (type === 'audCredibility') {
        this.searchFilter.credibility = ''
      }
      if (type === 'audGeo') {
        this.audGeos = []
        this.audGeoPercent = ''
      }
      if (type === 'followers') {
        this.searchFilter.followers = {from: '', to: ''}
      }
      if (type === 'ageGroup') {
        this.searchFilter.ageGroup = ''
        this.searchFilter.ageGroupPercent = ''
        this.searchFilter.secAgeGroup = ''
        this.searchFilter.secAgeGroupPercent = ''
      }
      if (type === 'infInterests') {
        this.searchFilter.infInterest = []
      }
      if (type === 'audInterests') {
        this.searchFilter.audienceInterest = []
      }
      if (type === 'engRate') {
        this.searchFilter.engagementRate = {to: ''}
      }
      if (type === 'paidPstRet') {
        this.searchFilter.paidPstPerformance = {from: '', to: ''}
      }
      this.removeItemFromFilterList(type)
      this.paginate()
    },
    setFilterItem(type, data) {
      let existIdx = this.searchFilterLists.findIndex(s => s.type === type)
      if (existIdx !== -1) {
        this.searchFilterLists[existIdx] = data
      } else {
        this.searchFilterLists.push(data)
      }
    },
    removeItemFromFilterList(type) {
      this.searchFilterLists = Object.assign([], this.searchFilterLists.filter(sList => sList.type !== type))
    }
  },
  async created() {
    if (this.$route.query.handle) {
      this.igHandle = this.$route.query.handle
    }
    if (this.$route.query.platform) {
      this.selectedPlatform = this.$route.query.platform
    }
    this.paginate(this.currentPage);
    this.getCountries();
    this.userGender_options = config.userGenderDisplay;
    this.getUsers()
    await this.getUserProfile()
    await this.$store.dispatch('campaign/getCampaigns')
    this.filterCampaigns = Object.assign([], this.campaigns)
    this.filterCampaigns.unshift({
      id: 'all',
      name: 'All Campaigns'
    }, {
      id: 'AOK',
      name: 'AOK Campaigns'
    }, {
      id: 'storytell',
      name: 'Storytell Campaigns'
    }, {
      id: 'empty',
      name: 'Empty Campaigns'
    })
  }
};
</script>
<style scoped>
  .table-small tbody td {
    padding: 5px!important;
  }
  .table-small tbody td .input-field {
    font-size:13px;
  }
  .table-small tbody td .custom-checkbox {
    padding: 0 16px;
  }
  .table-small tbody td.text-start, 
  .table-small tbody td.text-xs-left, 
  .table-small tbody td.text-center {
    font-size: 11px!important;
  }

  .table-small tbody td.text-xs-left {
    padding-left: 10px!important;
    font-size: 14px!important;
  }

  .btn-close {
    min-width: 15px!important;
    max-width: 15px!important;
    padding-right: 3px!important;
  }

  #progressbar li {
    list-style-type: none;
    color: #99a2a8;
    font-size: 12px;
    width: 4px;
    float: left;
    position: relative;
  }

  #progressbar li:before {
    content: "";
    width: 10px;
    line-height: 50px;
    display: block;
    background: #eaf0f4;
    margin: 11px auto 10px auto;
  }

  #progressbar li.median span {
    margin-left: -15px;
  }

  #progressbar li.median:before {
    height: 10px;
    background: rgb(249, 168, 37);
    width: 3px;
    margin: 30px auto 0px auto;
  }

  #progressbar li:after {
    content: "";
    width: 100%;
    height: 10px;
    background: #eaf0f4;
    position: absolute;
    left: -50%;
    top: 21px;
  }

  #progressbar li.active.green-color:before {
    background: #5cb85c;
    color: white;
  }

  #progressbar li.active.green-color:after {
    background: #5cb85c;
    color: white;
  }

  #progressbar li.active.red-color:before {
    background: #ff0202;
    color: white;
  }

  #progressbar li.active.red-color:after {
    background: #ff0202;
    color: white;
  }

  #progressbar li.median.green-color:after {
    background: #5cb85c;
    color: white;
  }

  #progressbar li.median.red-color:after {
    background: #ff0202;
    color: white;
  }

  #progressbar li.active {
    color: #5cb85c;
  }
  
  .more-percent {
    font-size:11px;
    font-weight:500;
    padding-top: 5px;
  }
</style>
<style>
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.search-keyword-wrapper {
  padding-right: 2px;
}
nav hr {
  margin-top: 0px !important;
}
.ims-action {
  margin: 6px 1px !important;
  min-width: 35px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// NonIMSLists.vue?5e82bc8b